// extracted by mini-css-extract-plugin
export default {"component":"TextInput_component__0g+1j","smallVariant":"TextInput_smallVariant__kk1cv","dark":"TextInput_dark__CsstF"};